<template>
    <div class="jetlympic-schedule">
      <div class="header">
         <div class="search">
          <van-search v-model="keyword" show-action placeholder="请输入搜索关键词" >
            <template #action>
              <div class="search-btn" @click="onSearch">搜索</div>
            </template>
          </van-search>
         </div>
         <div class="tabs">
          <van-tabs v-model="active" title-active-color="#00AAFF" color="#00AAFF" @change="onTabChange">
            <van-tab v-for="tab in tabs" :key="tab.value" :title="tab.name"></van-tab>
          </van-tabs>
        </div>
      </div>
      <div class="list">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list 
          v-model="loading" 
          :finished="getFinishedState()" 
          finished-text="没有更多了" 
          :immediate-check="false"
          @load="onLoad"
        >
            <div v-for="dateGroup in groupedList" :key="dateGroup.date">
              <div class="item">
                <div class="time">{{ dateGroup.displayDate }}</div>
                <div class="game-item" v-for="game in dateGroup.games" :key="game.id" @click="goSchedule(game)">
                  <div class="left">
                    <div>{{ getTime(game.beginDate) }}</div>
                    <div>{{ game.sportType }}</div>
                    <div class="overflow-text">
                      <span v-if="game.roundAlias">{{ game.roundAlias}}</span>
                      <span v-else>{{ game.roundName}}</span>
                    </div>
                  </div>
                  <div class="center" v-if="game.homeTeamId && game.awayTeamId">
                    <div class="team flex-center">
                      <div class="team-name overflow-text">
                        <span v-if="game.homeAlias">{{ game.homeAlias}}</span>
                        <span v-else>{{ game.homeName}}</span>
                      </div>
                      <div class="team-score" v-if="game.homeScore !== -1">{{ game.homeScore }}</div>
                    </div>
                    <div class="team flex-center">
                      <div class="team-name overflow-text">
                        <span v-if="game.awayAlias">{{ game.awayAlias}}</span>
                        <span v-else>{{ game.awayName}}</span>
                      </div>
                      <div class="team-score" v-if="game.awayScore !== -1">{{ game.awayScore }}</div>
                    </div>
                  </div>
                  <div class="center" style="align-self: center;font-size: 13px;color: #3D3D3D" v-else>
                    <div>{{ game.name }}</div>
                  </div>
                  <div class="right">
                    <div class="type">
                      <div v-if="game.liveStatus === 1" class="play-icon">
                        <van-icon name="play" />直播中
                      </div>
                      <div v-else-if="game.liveStatus === 2" class="lookBack">
                        <van-icon name="play" />回看
                      </div>
                      <div v-else>{{ getGameStatus(game) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Search, Tabs, Tab, List, PullRefresh } from 'vant';
Vue.use(Search).use(Tabs).use(Tab).use(List).use(PullRefresh);
import { getOrganizationGameList } from '@/api/match';
import { DateUtil } from '@/utils';
export default {
      data() {
        return {
          accountId: '',
          keyword: '',
          sportType: '',
          tabs: [
            { name: this.$t(`jetlympic.sportType.全部`), value: '' },
            { name: this.$t(`jetlympic.sportType.篮球`), value: '篮球' },
            { name: this.$t(`jetlympic.sportType.足球`), value: '足球' },
            { name: this.$t(`jetlympic.sportType.羽毛球`), value: '羽毛球' },
            { name: this.$t(`jetlympic.sportType.乒乓球`), value: '乒乓球' }
          ],
          active: 0,
          list: [],
          groupedList: [],
          loading: false,
          finishedUp: false, // 上滑加载完成状态
          finishedDown: false, // 下拉加载完成状态
          refreshing: false,
          pageNumUp: 1, // 上滑页码
          pageNumDown: 1, // 下拉页码
          pageSize: 10,
          isDown: 1 // 1上滑加载未来数据, 0下滑加载历史数据
        };
  },
  mounted() { 
    this.accountId = this.$route.query.accountId;
      this.onLoad();
    },
  methods: {
    goSchedule(game) { 
      if (game.liveStatus === 1) {
        if (process.env.NODE_ENV === 'development') {
          window.location.href = `https://www.snsports.cn/webapp-bmb-stage/index.html#/game1/${game.id}/videoList`
        } else {
          window.location.href = `https://www.snsports.cn/webapp-bmb/index.html#/game1/${game.id}/videoList`
        }
      } else {
        this.$router.push({ path: '/event/activity', query: { gameId: game.id } })
      }
    },

      onRefresh() {
        // 下拉刷新：加载历史数据
        this.isDown = 0;
        this.getOrganizationGameList()
      },
      onLoad() {        
        // 上滑加载：加载未来数据
        this.isDown = 1;
        this.getOrganizationGameList();
      },
      onSearch() {
        this.resetList();
        this.isDown = 1; // 搜索默认加载未来数据
        this.getOrganizationGameList();
      },
      onTabChange() {
        this.resetList();
        this.isDown = 1; // 切换默认加载未来数据
        this.getOrganizationGameList();
      },
      resetList() {
        this.list = [];
        this.groupedList = [];
        this.pageNumUp = 1;
        this.pageNumDown = 1;
        this.finishedUp = false;
        this.finishedDown = false;
        this.loading = false;
      },
      getFinishedState() {
        // 根据当前加载方向返回对应的 finished 状态
        return this.isDown ? this.finishedUp : this.finishedDown;
      },
      getOrganizationGameList() {
        // const finished = this.isDown ? this.finishedUp : this.finishedDown;
        // if (this.loading || finished) {
        //   return Promise.resolve();
        // }
        
        this.loading = true;
        const pageNum = this.isDown ? this.pageNumUp : this.pageNumDown;
        const params = {
          keyword: this.keyword,
          sportType: this.tabs[this.active].value,
          accountId: this.accountId,
          pageNum: pageNum,
          pageSize: this.pageSize,
          isDown: this.isDown
        }
        
        return getOrganizationGameList(params).then(res => {
          const { data } = res
          const list = data.list || []
          
          if (list.length > 0) {
            // 根据加载方向决定添加方式和页码
            if (this.isDown === 1) {
              // 上滑加载未来数据：concat 到后面
              this.list = this.list.concat(list);
              this.pageNumUp++;
            } else {
              // 下拉加载历史数据：unshift 到前面
              this.list.unshift(...list);
              this.pageNumDown++;
            }
            
            if (list.length < this.pageSize) {
              if (this.isDown === 1) {
                this.finishedUp = true;
              } else {
                this.finishedDown = true;
              }
            }
          } else {
            // 没有数据时设置 finished
            if (this.isDown === 1) {
              this.finishedUp = true;
            } else {
              this.finishedDown = true;
            }
          }
          
          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          this.groupGamesByDate();
        }).catch(() => {
          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
        })
      },
      groupGamesByDate() {
        const grouped = {};
        
        this.list.forEach(game => {
          if (game.beginDate) {
            // 获取日期作为 key，格式为 yyyy-mm-dd
            const dateKey = DateUtil.parseDateTime(game.beginDate, '{y}-{m}-{d}');
            
            if (!grouped[dateKey]) {
              grouped[dateKey] = {
                date: dateKey,
                displayDate: this.formatDisplayDate(game.beginDate),
                games: []
              };
            }
            
            grouped[dateKey].games.push(game);
          }
        });
        
        // 对每个日期组内的游戏按时间排序
        Object.values(grouped).forEach(group => {
          group.games.sort((a, b) => {
            return new Date(a.beginDate) - new Date(b.beginDate);
          });
        });
        
        // 转换为数组并按日期排序
        this.groupedList = Object.values(grouped).sort((a, b) => {
          return new Date(a.date) - new Date(b.date);
        });
      },
      formatDisplayDate(date) {
        // 格式化显示：2025/05/01 今天
        const dateStr = DateUtil.parseDateTime(date, '{y}/{m}/{d}');
        const today = new Date();
        const currentDateStr = DateUtil.parseDateTime(today, '{y}-{m}-{d}');
        const displayDate = DateUtil.parseDateTime(date, '{y}-{m}-{d}');
        
        if (displayDate === currentDateStr) {
          return `${dateStr} 今天`;
        }
        return dateStr;
      },
      getTime(date) {
        // 获取时间部分 HH:mm
        return DateUtil.parseDateTime(date, '{h}:{i}');
      },
      getGameStatus(game) {
        // 根据 gameStatus 或其他字段判断比赛状态
        if (game.liveStatus === 1) {
          return '直播中';
        } else if (game.liveStatus === 2) {
          return '回看';
        } else if (game.gameStatus === 0) {
          return '未开赛';
        } else if (game.gameStatus === 1) {
          return '进行中';
        } else if (game.gameStatus === 2) {
          return '已完赛';
        }
        return '';
      }
    },
};
</script>

<style scoped lang="scss">
.jetlympic-schedule{
  .header{
    .search{
      height: 55px;
      .van-search{
        background-color: #F4F4F5 !important;
      }
      .van-search__content{
        height:35px !important;
        box-sizing: border-box;
        background-color: #FFF !important;
      }
      
      .search-btn{
        width: 58px;
        height: 35px;
        border-radius: 3px;
        background: #00AAFF;
        font-size: 15px;
        color: #FFFFFF;
        text-align: center;
        line-height: 35px;
      }
    }
    .tabs{
      border-bottom: 1px solid #eee;
    }
  }
  .list{
    padding: 16px;
    padding-top: 0;
    .item{
      margin-bottom: 16px;
      &:last-child{
        margin-bottom: 0;
      }
      .time{
        text-align: center;
        font-size: 14px;
        color: #3D3D3D;
        padding: 12px 0;
        padding-bottom: 0;
      }
      .game-item{
        display: flex;
        padding: 16px;
        border-bottom: 1px solid #eee;
        padding-right: 0px;
        &:last-child{
          border-bottom: none;
        }
        .left{
          width: 80px;
          div:nth-child(1){
            font-size: 16px;
            font-weight: 600;
            color: #00AAFF;
            margin-bottom: 8px;
          }
          div:nth-child(2){
            font-size: 14px;
            color: #333;
            margin-bottom: 4px;
          }
          div:nth-child(3){
            font-size: 12px;
            color: #999;
          }
        }
        .center{
          flex: 1;
          padding: 0 16px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .team{
            margin-bottom: 8px;
            &:last-child{
              margin-bottom: 0;
            }
            .team-name{
              font-size: 14px;
              color: #333;
            }
            .team-score{
              border-radius: 2px;
              background: #F0F0F3;
              font-size: 14px;
              color: #3D3D3D;
              padding: 3px;

            }
          }
        }
        .right{
          width: 60px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .type{
            font-size: 12px;
            color: #999;
            .play-icon{
              width: 57px;
              height: 22px;
              border-radius: 2px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #D54F3F;
              background-color: rgba($color: #D54F3F, $alpha: 0.2);
              font-size: 12px;
            }
            .lookBack{
              width: 57px;
              height: 22px;
              border-radius: 2px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #00AAFF;
              background-color: rgba($color: #00AAFF, $alpha: 0.2);
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
